export default {
    methods: {
        formatterSum(row, column, cellValue) {
            return cellValue + '元';
        },
        formatterPhone(row, column, cellValue) {
            if (cellValue === '0') {
                return "未绑定";
            } else {
                return cellValue;
            }
        },
        formatterCardName(row, column, cellValue) {
            if (cellValue === '0') {
                return "未绑定";
            } else {
                return cellValue;
            }
        },
    }
}